import FormHelpers from "../../../../helpers/FormHelpers";

const validateDocLevel = ({
  selectedTenant,
  tenantDepartmentId,
  documentUINames,
  orderDate,
  isEstimate,
  deliveryDate,
  selectedCustomer,
  selectedPriceList,
  cfSalesOrderDoc,
  shippingAddress,
  billingAddress,
  user,
  chargeData,
  gstNumber,
}) => {
  let docLevelErrors = [];

  const isPriceListMandatory = user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.is_price_list_mandatory;
  const isShippingAddressMandatory = user?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.is_shipping_address_mandatory;
  const isBillingAddressMandatory = user?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.is_billing_address_mandatory;
  const isDeliveryDateMandatory = user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.delivery_date_mandatory;

  if (!window.location.href.includes("/estimate")) {
    docLevelErrors.push({
      name: "Location",
      value: selectedTenant,
      message: `Error in Location. Select a location then proceed.`,
    });
  }
  docLevelErrors.push({
    name: "Department",
    value: tenantDepartmentId,
    message: `Error in Department. Select a department then proceed.`,
  });
  docLevelErrors.push({
    name: `${documentUINames?.shortUIName} Date`,
    value: orderDate,
    message: `Error in ${documentUINames?.shortUIName} Date. Pick a date then proceed.`,
  });
  if (!isEstimate && isDeliveryDateMandatory) {
    docLevelErrors.push({
      name: "Delivery Date",
      value: deliveryDate,
      message: `Error in Delivery Date. Pick a date then proceed.`,
    });
  }
  docLevelErrors.push({
    name: "Customer",
    value: selectedCustomer,
    message: `Error in Customer. Select a customer then proceed.`,
  });

  if(isPriceListMandatory && !isEstimate){
      docLevelErrors.push({
        name: "Price List",
        value: selectedPriceList,
        message: `Error in Price List. Select a Price List then proceed.`,
      });
  }
 
  for (let item of (cfSalesOrderDoc || [])) {
    if (item?.isRequired && item?.isActive) {
      docLevelErrors.push({
        name: item?.fieldName,
        value: item?.fieldValue,
        message: `Error in ${item?.fieldName}. Select/Enter a value then proceed.`,
      });
    }
  }

  if (isEstimate ? isShippingAddressMandatory : true) {
    docLevelErrors.push({
      name: "Shipping Address",
      value: shippingAddress,
      message: `Error in Shipping Address. Enter address to proceed.`,
    });
  }
  if (isEstimate ? isBillingAddressMandatory : true) {
    docLevelErrors.push({
      name: "Billing Address",
      value: billingAddress,
      message: `Error in Billing Address. Enter address to proceed.`,
    });
  }
  for (let item of (chargeData||[])) {
    docLevelErrors.push({
      name: "Charge Name",
      value: item?.charge_name,
      message: "Error in Charges. Fill charge name to proceed.",
    });
    docLevelErrors.push({
      name: "Charge Amount",
      value: item?.charge_amount,
      message: "Error in Charges. Fill charge amount to proceed.",
    });
  }
  if (!!gstNumber && String(gstNumber)?.length != 15 && String(gstNumber)?.length != 0) {
    docLevelErrors.push({
      name: "GST Number",
      value: 0,
      message: "Error in GST Number. Enter Valid GST Number.",
    });
  }

  return docLevelErrors;
}

const validateLineLevel = ({
  tenantDepartmentId,
  isEstimate,
  data,
}) => {
  let lineLevelErrors = [];

  if (tenantDepartmentId) {
    for (let item of data) {
      if (!item?.product_sku_info) {
        lineLevelErrors.push({
          name: "Products",
          value: 0,
          message: "Error in Product. Select a product to continue.",
        });
      }
      if (item?.child_taxes?.length === 0 || item?.child_taxes?.tax_name === "") {
        lineLevelErrors.push({
          name: "Tax",
          value: 0,
          message: `Error in Tax of product ${item?.product_sku_info?.internal_sku_code}. Select a value then proceed.`,
        });
      }
      for (const customField of (item?.lineCustomFields || [])) {
        if (isEstimate && customField?.fieldName === 'Quantity') {
          lineLevelErrors.push({
            name: customField?.fieldName,
            value: customField?.fieldValue,
            message: `Error in ${customField?.fieldName} of product ${item?.product_sku_info?.internal_sku_code}. Enter a non-zero value then proceed.`,
          });
        } else if (!isEstimate && customField?.fieldName === "Rate") {
          lineLevelErrors.push({
            name: customField?.fieldName,
            value: customField?.fieldValue,
            message: `Error in ${customField?.fieldName} of product ${item?.product_sku_info?.internal_sku_code}. Enter a value then proceed.`,
          });
        } else if (customField?.isRequired && customField?.isActive) {
          lineLevelErrors.push({
            name: customField?.fieldName,
            value: customField?.fieldValue,
            message: `Error in ${customField?.fieldName} of product ${item?.product_sku_info?.internal_sku_code}. Select/Enter a value then proceed.`,
          });
        }
      }
      
    }
  }

  return lineLevelErrors;
}

const salesErrors = (params) => {
  const docLevelErrors = validateDocLevel(params);
  const lineLevelErrors = validateLineLevel(params);

  return FormHelpers.errorChecker({ docLevelErrors, lineLevelErrors });
};

export default salesErrors;
